import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-loading-state',
  standalone: true,
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="loading-container">
      <div class="loading-spinner">
        <ukg-progress-circular></ukg-progress-circular>
      </div>
      <p class="loading-text">{{ message }}</p>
    </div>
  `,
  styles: [
    `
      .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 80px 24px;
        flex: 1;
        text-align: center;
      }

      .loading-text {
        font-size: 14px;
        color: #6b7280;
        margin: 0;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
      }
    `,
  ],
})
export class LoadingStateComponent {
  @Input() message = 'Loading...';
}
